import { render, staticRenderFns } from "./Folgen.vue?vue&type=template&id=0a133144&scoped=true"
import script from "./Folgen.vue?vue&type=script&lang=js"
export * from "./Folgen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a133144",
  null
  
)

export default component.exports